@let isLoading = loadingService.isLoading$(this) | async;

<form [formGroup]="form" [waiting]="isLoading">
  <div class="row">
    <div class="col grow">
      <icz-form-field
        formControlName="reason"
        label="Důvod zrušení vazby"
      ></icz-form-field>
    </div>
  </div>
</form>

<icz-form-buttons>
  <icz-button leftButtons iczFormSubmit
              [disabled]="isLoading"
              (onAction)="submit()"
              primary label="Zrušit vazbu"
  ></icz-button>
  <icz-button rightButtons
              [disabled]="isLoading"
              (onAction)="cancel()" label="Storno"
  ></icz-button>
</icz-form-buttons>
